// İSG Portal — form/detay bölüm başlığı (S34-1 A5, web-ui-designer review M16; S34-12 QA
// follow-up). Altı web-expert modalı (`PermitFormModal`, `ContractorFormModal`, `CheckInModal`,
// `PermitTypeFormModal`, `VisitDetailModal`, `EntryDetailModal`) aynı hatayı kopyalıyordu:
// `<legend>`/`<h3>` başlığı, kapsayıcının `flex flex-col gap-4`süne güvenerek altındaki alandan
// ayrılacağını varsayıyordu — ama bir `<legend>`, `<fieldset>`inin flex ÇOCUĞU DEĞİLDİR (tarayıcı
// onu fieldset'in normal içerik kutusunun DIŞINDA, kendi "rendered legend" kutusunda konumlandırır),
// dolayısıyla `gap-4` ASLA legend'in altına uygulanmaz.
//
// İlk düzeltme (S34-1) başlığa kendi `mb-4`'ünü verdi. Bu, dolgusuz (padding'siz) `<fieldset>`
// için doğruydu ama İKİ durumda 16px yerine 32px'e katlanıyordu (S34-12 QA, `CheckInModal`
// "Acknowledgements" + `VisitDetailModal` her iki `<h3>` bölümü):
//   1. `variant="section"` — `<h3>`, `<legend>`'in aksine GERÇEK bir flex çocuğudur, yani
//      `<section>`'ın `gap-4`'ü zaten `<h3>` ile ilk kardeşi arasında 16px veriyordu; başlığın
//      kendi `mb-4`'ü bunun ÜSTÜNE biniyor, margin flex `gap`'le ASLA çökmediği için 16+16=32px.
//   2. `variant="fieldset"` + kapsayıcıya dolgu eklenmiş (örn. kutulu bir onay bloğu, `p-4`) —
//      `<legend>` yine flex çocuğu değil ama tarayıcı onu fieldset'in KENAR (border) kutusuna
//      göre konumlandırır; fieldset'in KENDİ `padding-top`'u, legend'in konumundan bağımsız
//      olarak ilk gerçek çocuğu aşağı itiyor. Legend'in `mb-4`'ü BUNUN da üstüne biniyor →
//      yine 16(padding-top)+16(mb-4)=32px.
//
// Kök düzeltme: başlık ARTIK kendi dikey margin'ini TAŞIMIYOR. `section` variant'ı salt `gap-4`'e
// güvenir (başlık gerçek bir flex çocuğu olduğundan bu tek başına yeterli ve doğru). `fieldset`
// variant'ı, legend'in flex dışı konumlandırmasını telafi etmek için dolguyu KENDİSİ sabit
// `pt-4` (spacing-05) ile taşır — bu tek kaynak olduğundan çağıranın `className`'i ayrıca dolgu
// eklerse (örn. kutulu bir bölüm) yalnız `px-*`/`pb-*` vermeli, `p-*`/`pt-*` VERMEMELİ (aksi halde
// Tailwind çakışma çözümü çağıranınkini kazandırır ve hata geri gelir — bkz. `CheckInModal`
// "Onaylar" bloğu).
//
// `variant="fieldset"` (varsayılan) gerçek form kontrolleri içeren bölümler için — `<fieldset>` +
// `<legend>`, doğru erişilebilirlik grubu (legend fieldset'in İLK çocuğu). `variant="section"`
// salt-okunur detay blokları için (`VisitDetailModal`/`EntryDetailModal`in `<dl>` satırları) —
// `<fieldset>` FORM KONTROLLERİNİ gruplar, hiç kontrolü olmayan salt-okunur bir listeye
// uygulamak yanlış semantik olurdu; `<section>` + `<h3>` kullanır.

import type { ReactNode } from 'react';
import { cn } from './cn';

export interface FormSectionProps {
  /** Bölüm başlığı — `fieldset` variant'ında `<legend>`, `section` variant'ında `<h3>`. */
  legend: ReactNode;
  children: ReactNode;
  /**
   * `fieldset` variant'ında dolgu eklenecekse SADECE `px-*`/`pb-*` kullan — üst dolgu
   * (`pt-4`, spacing-05) bileşenin kendisinden gelir; `p-*`/`pt-*` vermek onu ezer (32px hatası
   * geri gelir).
   */
  className?: string;
  /** Başlığın kendi sınıflarına EK (örn. kutulu bir bölümde `px-1`). Dikey margin EKLEME. */
  legendClassName?: string;
  /** @default 'fieldset' */
  variant?: 'fieldset' | 'section';
}

export function FormSection({
  legend,
  children,
  className,
  legendClassName,
  variant = 'fieldset',
}: FormSectionProps) {
  const headingClassName = cn('text-sm font-semibold text-fg', legendClassName);
  if (variant === 'section') {
    // `<h3>` gerçek bir flex çocuğudur — `gap-4` tek başına legend→ilk-çocuk boşluğunu verir,
    // başlığa ayrıca margin eklemek `gap`'in üstüne biner (bkz. üstteki dosya notu).
    return (
      <section className={cn('flex flex-col gap-4', className)}>
        <h3 className={headingClassName}>{legend}</h3>
        {children}
      </section>
    );
  }
  // `<legend>` flex çocuğu DEĞİLDİR; boşluk fieldset'in kendi `pt-4`'ünden (spacing-05) gelir —
  // çağıranın `className`'i yalnız `px-*`/`pb-*`/`border`/`bg-*` eklemeli, üst dolguyu değil.
  return (
    <fieldset className={cn('flex flex-col gap-4 pt-4', className)}>
      <legend className={headingClassName}>{legend}</legend>
      {children}
    </fieldset>
  );
}
